'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _authReportRow = require('../auth-report-row');

var _authReportRow2 = _interopRequireDefault(_authReportRow);

var _reportHeader = require('./../report-header');

var _reportHeader2 = _interopRequireDefault(_reportHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthReport = function AuthReport(_ref) {
  var discussions = _ref.discussions,
      isLoading = _ref.isLoading,
      name = _ref.name,
      createdBy = _ref.createdBy;

  var headerProps = {
    campaignName: name,
    reportType: 'Authorisation Status',
    reportDate: (0, _moment2.default)().format('DD-MM-YYYY')
  };
  return _react2.default.createElement(
    'div',
    null,
    !isLoading && discussions && _react2.default.createElement(
      _semanticUiReact.Table,
      { textAlign: 'center' },
      _react2.default.createElement(
        _semanticUiReact.Table.Header,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            'Profile Picture'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            { textAlign: 'left' },
            'Name/Handle'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            'Invited'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            'Accepted'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            'Facebook'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            'Instagram'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            'Youtube'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            'Twitter'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            'Email/Link'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Body,
        null,
        _lodash2.default.map(discussions, function (discussion) {
          return _react2.default.createElement(_authReportRow2.default, { discussion: discussion });
        })
      )
    )
  );
};

AuthReport.propTypes = {
  discussions: _propTypes2.default.array,
  isLoading: _propTypes2.default.bool.isRequired,
  name: _propTypes2.default.string.isRequired,
  createdBy: _propTypes2.default.string.isRequired
};

AuthReport.defaultProps = {
  discussions: []
};

exports.default = AuthReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/auth-report/index.js
// module id = 2208
// module chunks = 1